import { RouteObject } from 'react-router-dom';
import ValueAtRiskOverview from '../components/pages/ucits/var/ValueAtRiskOverview';
import ValueAtRiskNew from '../components/pages/sharedComponents/valueAtRiskNew/ValueAtRiskNew.component';
import UcitsLaw from '../components/pages/ucits/law/UcitsLaw';
import ExposureOverview from '../components/pages/sharedComponents/ExposureOverview';
import ProspectusRestrictionsOverview from '../components/pages/risk/prospectusRestrictions/ProspectusRestrictionsOverview.component';
import ExposureFund from '../components/pages/sharedComponents/ExposureFund';
import ProspectusRestrictions from '../components/pages/risk/prospectusRestrictions/ProspectusRestrictions.component';
import FailsPage from '../components/pages/utilities/Fails/FailsPage';
import ShareClassHedgeDataOverview from '../components/pages/reportsPages/shareClassHedge/ShareClassHedgeData.overview';
import ShareClassHedgeData from '../components/pages/reportsPages/shareClassHedge/ShareClassHedgeData.component';
import HistoricalDataExport from '../components/pages/manco/historicalDataExport/HistoricalDataExport.component';
import UcitsLawOverviewPage from '../components/pages/ucits/law/UcitsLawOverview';
import { CombinedRoutePaths } from './page-routes';
import { SimpleGeneralPageWrapper } from '../components/layout/general/SimpleGeneralPageWrapper';
import SupplementaryRulesOverview from '../components/pages/risk/supplementaryRules/SupplementaryRulesOverview';
import SupplementaryRulesPage from '../components/pages/risk/supplementaryRules/SupplementaryRulesPage';

// This is to handle the custom fund picker pages, a better solution might be available
export const CombinedRoutes = (data: any): RouteObject[] => [
  {
    path: CombinedRoutePaths.VALUE_AT_RISK,
    element: (
      <SimpleGeneralPageWrapper
        pageId={'value-at-risk'}
        Component={ValueAtRiskOverview}
      >
        {/* Props will be injected by SimpleGeneralPageWrapper via React.cloneElement */}
        <ValueAtRiskNew {...({} as any)} />
      </SimpleGeneralPageWrapper>
    ),
  },

  {
    path: CombinedRoutePaths.UCITS_LAW,
    element: (
      <SimpleGeneralPageWrapper
        pageId={'ucits-law'}
        Component={UcitsLawOverviewPage}
      >
        {/* Props will be injected by SimpleGeneralPageWrapper via React.cloneElement */}
        <UcitsLaw {...({} as any)} />
      </SimpleGeneralPageWrapper>
    ),
  },
  {
    path: CombinedRoutePaths.EXPOSURE,
    element: (
      <SimpleGeneralPageWrapper
        pageId={'exposure'}
        Component={ExposureOverview}
      >
        {/* Props will be injected by SimpleGeneralPageWrapper via React.cloneElement */}
        <ExposureFund {...({} as any)} />
      </SimpleGeneralPageWrapper>
    ),
  },
  {
    path: CombinedRoutePaths.PROSPECTUS_RESTRICTIONS,
    element: (
      <SimpleGeneralPageWrapper
        pageId={'prospectus-restrictions'}
        Component={ProspectusRestrictionsOverview}
      >
        {/* Props will be injected by SimpleGeneralPageWrapper via React.cloneElement */}
        <ProspectusRestrictions {...({} as any)} />
      </SimpleGeneralPageWrapper>
    ),
  },
  {
    path: CombinedRoutePaths.SUPPLEMENTARY_RULES,
    element: (
      <SimpleGeneralPageWrapper
        pageId={'supplementary-rules'}
        Component={SupplementaryRulesOverview}
      >
        {/* Props will be injected by SimpleGeneralPageWrapper via React.cloneElement */}
        <SupplementaryRulesPage {...({} as any)} />
      </SimpleGeneralPageWrapper>
    ),
  },
  {
    path: CombinedRoutePaths.FAILS,
    element: (
      <SimpleGeneralPageWrapper pageId={'fails'} Component={<h1>Fails</h1>}>
        {/* Props will be injected by SimpleGeneralPageWrapper via React.cloneElement */}
        <FailsPage {...({} as any)} />
      </SimpleGeneralPageWrapper>
    ),
  },

  {
    path: CombinedRoutePaths.SHARE_CLASS_HEDGE,
    element: (
      <SimpleGeneralPageWrapper
        pageId={'share-class-hedge'}
        Component={ShareClassHedgeDataOverview}
      >
        {/* Props will be injected by SimpleGeneralPageWrapper via React.cloneElement */}
        <ShareClassHedgeData {...({} as any)} />
      </SimpleGeneralPageWrapper>
    ),
  },
  {
    path: CombinedRoutePaths.HISTORICAL_DATA_EXPORT,
    element: (
      <SimpleGeneralPageWrapper
        pageId={'historical-data-export'}
        Component={HistoricalDataExport}
      >
        {/* Props will be injected by SimpleGeneralPageWrapper via React.cloneElement */}
        <HistoricalDataExport {...({} as any)} />
      </SimpleGeneralPageWrapper>
    ),
  },
];
